<template>
  <div>
    <div class="content">
      <div style="display: flex;justify-content: space-between">
        <Input search enter-button placeholder="请输入名称" style="width: 250px" v-model="searchContent"
         @on-search='searchBtn' />
      </div>
      <div class="tableBox">
        <el-table :data="tableData" border
                  :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
                  style="width: 100%">
          <el-table-column
              type="index"
              :index='(index) => {return index + 1 + (curPage-1)*limit}'
              label="序号"
              width="70">
          </el-table-column>
          <el-table-column prop="alarmType" label="报警类型"></el-table-column>
          <el-table-column prop="alarmTime" label="报警时间"></el-table-column>
          <el-table-column prop="deviceIp" label="设备ip"></el-table-column>
          <el-table-column prop="alarmStatus" label="报警状态">
            <template slot-scope="{ row }">
              <el-tag v-if="row.alarmStatus === 0" effect="dark" type="danger" size="small">未处理</el-tag>
              <el-tag v-if="row.alarmStatus === 1" effect="dark" type="warning" size="small">已处理</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="{ row }">
              <el-link :underline="false" style="color: #086ff5; padding: 0 2px" @click="handleAlarmBtn(row)">处理</el-link>
              <el-link :underline="false" style="color: #22d225; padding: 0 2px" @click="viewAlarmBtn(row)">查看</el-link>
              <el-link :underline="false" style="color: #f50606; padding: 0 2px" @click="deleteAlarmBtn(row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 15px; text-align: right">
          <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
        </div>
      </div>
    </div>

    <Modal title="查看视频监控报警" v-model="showViewAlarmModal">
      <div id="qrCode">
        <img :src="form.alarmImage">
      </div>
    </Modal>

    <el-dialog :visible.sync="showHandleAlarmDialog" :title="'处理视频监控报警'" width="30%">
      <el-form>
        <el-form-item label="状态">
          <el-select v-model="form.alarmStatus" placeholder="请选择状态">
            <el-option label="未处理" :value="0"></el-option>
            <el-option label="已处理" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="showHandleAlarmDialog = false">取 消</el-button>
            <el-button type="primary" @click="submitHandleAlarmForm()">确 定</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getNvrAlarmList,
  nvrAlarmAdd,
  nvrAlarmUpdate,
  nvrAlarmDelete
} from "@/api/processManager";
export default {
  name: 'ProcessNvrAlarm',
  components: {
  },
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 10,
      curPage: 1,
      searchContent: '',
      showHandleAlarmDialog:false,
      showViewAlarmModal:false,
      form:{},
      userId:''
    }
  },
  created() {
    this.userId = Number(localStorage.getItem('userId'))
    this.getData();
  },
  methods: {
    // 获取表格数据
    getData() {
      getNvrAlarmList({ limit: this.limit, curPage: this.curPage, search: this.searchContent }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.cum;
      })
    },

    // 编辑按钮
    handleAlarmBtn(row) {
      this.showHandleAlarmDialog=true;
      this.form=row;
    },
    viewAlarmBtn(row) {
      this.showViewAlarmModal=true;
      this.form=row;
    },
    // 删除按钮
    deleteAlarmBtn(row) {
      this.$confirm(`删除风险点 "${row.alarmType}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        nvrAlarmDelete(row.id).then(res => {
          this.$message.success('删除成功');
          this.getData()
        })
      }).catch(() => {
        return
      });
    },
    // 搜索框
    searchBtn() {
      this.getData();
    },
    // 翻页的事件
    curPageChange(val) {
      this.curPage = val;
      this.getData();
    },

    /**
     * 保存危险因素
     */
    submitHandleAlarmForm() {
      let obj = { ...this.form }
      // 编辑
      if(obj.id) {
        nvrAlarmUpdate(obj).then(res => {
          this.$message.success('保存成功');
          this.getData();
          this.showHandleAlarmDialog=false;
        })
      }else{
        // 新增
        nvrAlarmAdd(obj).then(res => {
          this.$message.success('保存成功');
          this.getData();
          this.showHandleAlarmDialog=false;
        })
      }
    }
  }
}
</script>

<style scoped>
.tableBox {
  margin-top: 10px
}
.tagBox span {
  margin-bottom: 2px
}
.el-form-item{
  margin-bottom: 0px;
}
.el-col-12 /deep/{
  padding: 10px 10px;
}
</style>
